module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.loggedIn) ? _c('router-view', {
    on: {
      "toggleSpinner": _vm.toggleSpinner
    }
  }) : _c('div', {
    staticClass: "dashboard"
  }, [_c('DashboardHeader', {
    attrs: {
      "menu-showing": _vm.menuShowing,
      "alert": _vm.alert,
      "is-offline": _vm.$root.isOffline,
      "updateAvailable": _vm.updateAvailable,
      "page-title": _vm.pageTitle
    },
    on: {
      "toggleMenu": function($event) {
        _vm.menuShowing ? _vm.menuShowing = false : _vm.menuShowing = true
      },
      "newAudit": function($event) {
        _vm.auditDialog.visible = true
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modalOverlayFade",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut"
    }
  }, [(_vm.alert.visible) ? _c('div', {
    staticClass: "alert main-alert",
    class: _vm.alert.class
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.alert.icon
  }), _vm._v("\n        " + _vm._s(_vm.alert.msg) + "\n        "), (_vm.alert.errors) ? _c('p', [_vm._v(_vm._s(_vm.alert.errors))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-wrapper",
    class: {
      menuShowing: _vm.menuShowing
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('router-view', {
    attrs: {
      "is-offline": _vm.$root.isOffline,
      "clients": _vm.clients
    },
    on: {
      "updateAlert": _vm.updateAlert,
      "updateLoginStatus": _vm.updateLoginStatus,
      "toggleSpinner": _vm.toggleSpinner,
      "clientsChanged": _vm.fetchClients,
      "newAudit": _vm.newAudit,
      "pageTitle": _vm.setPageTitle
    }
  })], 1)], 1), _vm._v(" "), (_vm.spinnerVisible) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.auditDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.auditDialog.title,
      "modal-visible": _vm.auditDialog.visible,
      "confirm-button-text": _vm.auditDialog.buttonText,
      "button-class": _vm.auditDialog.buttonClass
    },
    on: {
      "confirm": _vm.createNewAudit,
      "closeModal": function($event) {
        _vm.auditDialog.visible = false
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Client",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auditDialog.fields.client_id),
      expression: "auditDialog.fields.client_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.auditDialog.fields.client_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client.id
      }
    }, [_vm._v(_vm._s(client.company))])
  }))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Location",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auditDialog.fields.location_id),
      expression: "auditDialog.fields.location_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.auditDialog.fields.location_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.selectedClientLocations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.location_name))])
  }))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Audit Date",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    attrs: {
      "extra-classes": "form-control"
    },
    model: {
      value: (_vm.auditDialog.fields.audit_date),
      callback: function($$v) {
        _vm.auditDialog.fields.audit_date = $$v
      },
      expression: "auditDialog.fields.audit_date"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Form Template",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auditDialog.fields.form_template_id),
      expression: "auditDialog.fields.form_template_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.auditDialog.fields.form_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.auditTemplates), function(template) {
    return _c('option', {
      domProps: {
        "value": template.id
      }
    }, [_vm._v(_vm._s(template.form_name))])
  }))])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isOffline) ? _c('div', {
    staticClass: "offline-flag bg-danger"
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v("\n    You appear to be offline. The app is running in a limited state\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5558de97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 289
// module chunks = 0